import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, Home, ClipboardList, ExternalLink, ArrowRight, FileText, Users, Sprout, Fish, ShieldCheck, Beaker } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const applicationCategories = [{
  title: 'Crop Services Applications',
  icon: Sprout,
  color: 'bg-green-600',
  applications: [{
    name: 'Phytosanitary Certificate Application',
    link: '/import-export'
  }, {
    name: 'Plant Import Permit Application',
    link: '/import-export'
  }, {
    name: 'Seed Certification Application',
    link: '/guidelines-services'
  }, {
    name: 'Pesticide Registration Application',
    link: '/licensing'
  }, {
    name: 'Seed Dealer License Application',
    link: '/licensing'
  }, {
    name: 'Crop Variety Release Application',
    link: '/guidelines-services'
  }]
}, {
  title: 'Animal Health Applications',
  icon: ShieldCheck,
  color: 'bg-blue-600',
  applications: [{
    name: 'Veterinary Health Certificate Application',
    link: '/import-export'
  }, {
    name: 'Animal Import Permit Application',
    link: '/import-export'
  }, {
    name: 'Veterinary Drug Dealer License',
    link: '/licensing'
  }, {
    name: 'Livestock Movement Permit',
    link: '/guidelines-services'
  }, {
    name: 'Animal Disease Report Form',
    link: '/guidelines-services'
  }, {
    name: 'Artificial Insemination Service Request',
    link: '/agencies'
  }]
}, {
  title: 'Fisheries Applications',
  icon: Fish,
  color: 'bg-cyan-600',
  applications: [{
    name: 'Fishing License Application',
    link: '/licensing'
  }, {
    name: 'Fish Export Certificate Application',
    link: '/import-export'
  }, {
    name: 'Fish Processing Plant License',
    link: '/licensing'
  }, {
    name: 'Aquaculture Farm Registration',
    link: '/guidelines-services'
  }, {
    name: 'Beach Management Unit Registration',
    link: '/guidelines-services'
  }, {
    name: 'Fish Import Permit Application',
    link: '/import-export'
  }]
}, {
  title: 'Dairy & Livestock Applications',
  icon: Users,
  color: 'bg-purple-600',
  applications: [{
    name: 'Dairy Processing License Application',
    link: '/licensing'
  }, {
    name: 'Milk Collection Center Registration',
    link: '/agencies'
  }, {
    name: 'Dairy Trader License',
    link: '/licensing'
  }, {
    name: 'Breeding Stock Import Permit',
    link: '/import-export'
  }, {
    name: 'Hides & Skins Export Permit',
    link: '/import-export'
  }]
}, {
  title: 'Laboratory & Testing',
  icon: Beaker,
  color: 'bg-amber-600',
  applications: [{
    name: 'Soil Testing Request Form',
    link: '/guidelines-services'
  }, {
    name: 'Plant Pathology Diagnostic Request',
    link: '/guidelines-services'
  }, {
    name: 'Veterinary Laboratory Test Request',
    link: '/guidelines-services'
  }, {
    name: 'Food Safety Analysis Request',
    link: '/guidelines-services'
  }, {
    name: 'Water Quality Testing Request',
    link: '/guidelines-services'
  }]
}, {
  title: 'General Applications',
  icon: FileText,
  color: 'bg-gray-600',
  applications: [{
    name: 'Farmer Group Registration',
    link: '/guidelines-services'
  }, {
    name: 'Agricultural Input Subsidy Application',
    link: '/agencies'
  }, {
    name: 'Research Collaboration Request',
    link: '/agencies'
  }, {
    name: 'Complaint / Feedback Form',
    link: '/contact'
  }, {
    name: 'Access to Information Request',
    link: '/contact'
  }]
}];
export function ApplicationsPage() {
  return <>
      <Header data-id="element-566" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-567">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-568">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1593113598332-cd288d649433?w=1600&h=600&fit=crop")'
        }} data-id="element-569"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-570"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-571">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-572">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-573">
                <Home className="w-4 h-4 mr-1" data-id="element-574" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-575" />
              <span data-id="element-576">Services & Applications</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-577" />
              <span className="text-white font-medium" data-id="element-578">Applications</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-579">
              Applications & Forms
            </h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-580">
              Access all application forms, permits, licenses, and service
              request forms available from the Ministry of Agriculture, Animal
              Industry and Fisheries.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12" data-id="element-581">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-582">
            {applicationCategories.map((category, index) => {
            const Icon = category.icon;
            return <motion.div key={category.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 flex flex-col" data-id="element-583">
                  <div className={`w-12 h-12 rounded-xl ${category.color} flex items-center justify-center mb-5`} data-id="element-584">
                    <Icon className="w-6 h-6 text-white" data-id="element-585" />
                  </div>
                  <h3 className="text-xl font-bold text-uganda-black mb-4" data-id="element-586">
                    {category.title}
                  </h3>
                  <ul className="space-y-3 flex-grow" data-id="element-587">
                    {category.applications.map((app, i) => <li key={i} data-id="element-588">
                        <Link to={app.link} className="flex items-center gap-2 text-sm text-gray-600 hover:text-uganda-green transition-colors group" data-id="element-589">
                          <ClipboardList className="w-4 h-4 text-gray-400 group-hover:text-uganda-green flex-shrink-0" data-id="element-590" />
                          <span className="group-hover:underline" data-id="element-591">
                            {app.name}
                          </span>
                        </Link>
                      </li>)}
                  </ul>
                </motion.div>;
          })}
          </div>

          <div className="mt-12 bg-uganda-light-green rounded-xl p-8 border border-green-200" data-id="element-592">
            <h2 className="text-xl font-bold text-uganda-black mb-3" data-id="element-593">
              Need Help?
            </h2>
            <p className="text-gray-600 mb-4" data-id="element-594">
              If you cannot find the application form you need or require
              assistance with the application process, please contact us.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-595">
              <Link to="/contact" className="inline-flex items-center gap-2 bg-uganda-green text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition-colors" data-id="element-596">
                Contact Us <ArrowRight className="w-4 h-4" data-id="element-597" />
              </Link>
              <Link to="/guidelines-services" className="inline-flex items-center gap-2 bg-white border border-gray-200 text-uganda-black px-6 py-3 rounded-lg font-semibold hover:border-uganda-green hover:text-uganda-green transition-colors" data-id="element-598">
                View Guidelines <ArrowRight className="w-4 h-4" data-id="element-599" />
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-600" />
    </>;
}